import Api from '@/Api';

export default class UserApi extends Api {
  /**
   * Requests the API to send a list of users  recently added, updated, or registration pending
   * for a particular user
   * @param {Object}          params - key/value pair to be provided as url query parameters
   * @param {string}          params.userId - id of user to fetch history for
   */

  history = params => {
    if (params.userId === undefined) {
      console.warn('Unable to get history, invalid userId', params);
      return;
    }

    return this.post(`/api/v1/private/users/history`, params);
  };

  /**
   * Requests the API to send a list of users  recently added, updated, or registration pending
   * for all users
   * @param {Object}          params - key/value pair to be provided as url query parameters
   * @param {String}          params.action - user transaction action to search for
   */

  recentHistory = params => {
    if (params.action === undefined) {
      console.warn('Unable to get recent history, invalid action', params);
      return;
    }

    return this.get('/api/v1/private/users/recentHistory', params);
  };

  /**
   * Search for users
   * @param {Object}         params - key/value pair to be provided as the url query parameters
   * @param {String}         params.userId - "C05957"
   * @param {String}         params.groupId - "A10001"
   * @param {String}         params.groupName - Cognizant"
   * @param {String}         params.firstName - Herman"
   * @param {String}         params.lastName - Munster"
   * @param {String}         params.relatedUsersRequired - false
   * @param {String}         params.status - All
   */
  search = params => {
    return this.post('/api/v1/private/users/search', params);
  };

  /**
   * @param {Object[]}      params - Users to be updated
   * @param {Object}        params - User to be updated
   * @param {String}        params.userId
   * @param {String}        params.email
   * @param {String}        params.countryCode
   * @param {String}        params.phone
   * @param {String}        params.phoneType
   * @param {String}        params.accountType
   * @param {String}        params.firstName
   * @param {String}        params.lastName
   * @param {Boolean}       params.emailInvoice
   * @param {Boolean}       params.smsEnabled
   * @param {Object[]}      params.subGroupAccess[]
   * @param {String}        params.subGroupAccess[].groupCk
   * @param {String}        params.subGroupAccess[].groupId
   * @param {String}        params.subGroupAccess[].subGroupCk
   * @param {String}        params.subGroupAccess[].subGroupId
   * @param {String}        params.subGroupAccess[].subGroupName
   * @param {Object}        params.subGroupAccess[].access
   * @param {Boolean}       params.subGroupAccess[].access.primaryContact
   * @param {Boolean}       params.subGroupAccess[].access.memberSearchAllowed
   * @param {Boolean}       params.subGroupAccess[].access.memberMaintenanceAllowed
   * @param {Boolean}       params.subGroupAccess[].access.viewInvoicesAllowed
   * @param {Boolean}       params.subGroupAccess[].accecss.createGroupUsersAllowed
   */
  update = params => {
    return this.put('/api/v1/private/users', params);
  };

  /**
   * @param {Object}        params - User to be created
   * @param {String}        params.userId
   * @param {String}        params.email
   * @param {String}        params.accountType
   * @param {String}        params.firstName
   * @param {String}        params.lastName
   * @param {String}        params.countryCode
   * @param {String}        params.phone
   * @param {String}        params.phoneType
   * @param {String}        params.ext
   * @param {Boolean}       params.emailInvoice
   * @param {Boolean}       params.smsEnabled
   * @param {Object[]}      params.subGroupAccess[]
   * @param {String}        params.subGroupAccess[].groupCk
   * @param {String}        params.subGroupAccess[].groupId
   * @param {String}        params.subGroupAccess[].subGroupCk
   * @param {String}        params.subGroupAccess[].subGroupId
   * @param {String}        params.subGroupAccess[].subGroupName
   * @param {Object}        params.subGroupAccess[].access
   * @param {Boolean}       params.subGroupAccess[].access.primaryContact
   * @param {Boolean}       params.subGroupAccess[].access.memberSearchAllowed
   * @param {Boolean}       params.subGroupAccess[].access.memberMaintenanceAllowed
   * @param {Boolean}       params.subGroupAccess[].access.viewInvoicesAllowed
   * @param {Boolean}       params.subGroupAccess[].accecss.createGroupUsersAllowed
   */
  create = params => {
    console.log('create params', params);

    return this.post('/api/v1/private/users', params);
  };

  /**
   * Deactivates the user from the options.body.userId
   * @param {Object} options
   * @param {Object} options.body
   * @param {String} options.body.userId
   */
  deactivateUser = (options = {}) => {
    if (!options.body && !options.body.userId) {
      throw new Error('No user ID given');
    } else return this.delete('/api/v1/private/users', options.body);
  };

  getAccountTypeOptions = () => {
    return this.get(
      '/api/v1/private/configurations?category=user_account_type'
    );
  };

  getAccountTypeRelations = () => {
    return this.get(
      '/api/v1/private/configurations?category=account_type_relation'
    );
  };

  /**
   * Receives userId suggestions from the API only when firstName and lastName are provided
   * @param {Object} options
   * @param {Object} options.params
   * @param {String} options.params.firstName
   * @param {String} options.params.lastName
   * @returns {Promise}
   */
  getUserIdSuggestions = (options = {}) => {
    if (
      !(options.params && options.params.firstName && options.params.lastName)
    ) {
      throw new Error(
        'You must provide query params including firstName and lastName to getUserIdSuggestions'
      );
    }
    return this.get('/api/v1/private/users/suggestions', options.params);
  };

  userRole = (options = {}) => {
    return this.post(
      '/api/v1/private/users/role',
      options.body,
      options.params
    );
  };

  updatesmsOptInOut = (options = {}) => {
    return this.put('/api/v1/private/sms/optinout', options);
  };
}
